var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 22H6.94A2.913 2.913 0 014 19.059V4.94A2.913 2.913 0 016.941 2H17.53a2.913 2.913 0 012.942 2.941V19.06A2.913 2.913 0 0117.529 22zM6.94 3.176C6 3.176 5.176 4 5.176 4.941V19.06c0 .941.824 1.764 1.765 1.764H17.53c.942 0 1.765-.823 1.765-1.764V4.94c0-.941-.823-1.765-1.765-1.765H6.941z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.766 15.334H8.707c-.353 0-.588-.235-.588-.588s.236-.588.588-.588h7.06c.352 0 .588.235.588.588s-.236.588-.589.588zm0 2.876H8.707c-.352 0-.588-.236-.588-.589 0-.352.236-.588.588-.588h7.06c.352 0 .588.235.588.588s-.236.589-.589.589zm-3.348-7.06c-1.566 0-2.918-1.423-2.918-3.203 0-1.779 1.281-3.202 2.918-3.202 1.068 0 2.064.64 2.562 1.78.071.213 0 .355-.142.497-.214.071-.356 0-.498-.142-.356-.854-1.139-1.352-1.922-1.352-1.21 0-2.206 1.067-2.206 2.49 0 1.424.996 2.492 2.206 2.492.783 0 1.566-.499 1.922-1.353.07-.213.284-.284.498-.142.213.071.285.285.142.498-.498.997-1.494 1.637-2.562 1.637z",
    fill: "var(--color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.205 7.449H8.932c-.214 0-.356-.142-.356-.356 0-.213.142-.356.356-.356h3.273c.214 0 .356.143.356.356 0 .214-.142.356-.356.356zm0 1.921H8.93c-.213 0-.356-.142-.356-.355 0-.214.143-.356.356-.356h3.274c.213 0 .356.142.356.356 0 .213-.143.356-.356.356z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.a4cb13ea6fe4820abe8c3ff95fd09eef.svg";
export { ForwardRef as ReactComponent };